import resolve from '../../../../../modules/api/resolve';
import { apiPost, apiStore, generateFormData } from '../../../../../modules/apiHelper';
import { invalideDate, isStaleData, now } from '../../../../../modules/dataHelper';

export default {
  async saveProgramJourney(context, data) {
    const request = await resolve(apiPost('prog_create_journey', generateFormData({
      title: data.title,
      desc: data.description,
      companyid: data.companyId,
      progid: data.programId,
      admin: context.rootState.User.id,
    }), 82));

    return request;
  },

  async getProgramJourneys(context, [CompanyId, ProgramId, refresh = false]) {
    const companyid = CompanyId || context.rootState.User.companyid;
    const programid = ProgramId || context.rootState.User.programid;

    if (!companyid || !programid) return false;

    const journeys = await apiStore.getItem(`programJourneys/${companyid}/${programid}`) || [invalideDate, []];

    if (!refresh && !isStaleData(journeys[0]) && journeys[1].length) return journeys[1];

    const result = await resolve(apiPost('prog_company_jan', generateFormData({ progid: programid, companyid }), 82)).then((data) => {
      if (!data) return false;

      const companyJourneys = data.prog_company_jan || [];

      if (companyJourneys.length > 0) {
        apiStore.setItem(`programJourneys/${companyid}/${programid}`, [now(), companyJourneys]);
      }

      return companyJourneys;
    });

    return result;
  },
  async getProgramJourney(context, [journeyId, companyId, programId, refresh = false]) {
    const journeys = await context.dispatch('getProgramJourneys', [companyId, programId, refresh]);

    if (Array.isArray(journeys)) {
      return journeys.find((journey) => Number(journey.id) === Number(journeyId)) || false;
    }

    return false;
  },
  async getProgramJourneyActions(context, [journeyId, companyId, programId, refresh = false]) {
    const companyid = companyId || context.rootState.User.companyid;
    const programid = programId || context.rootState.User.programid;
    if (!companyid || !programid) return false;

    const apiStoreKey = `programJourneyActions/${journeyId}/${companyid}/${programid}`;
    const journeyActions = await apiStore.getItem(apiStoreKey) || [invalideDate, []];

    if (!refresh && !isStaleData(journeyActions[0]) && journeyActions[1].length) return journeyActions[1];

    const result = await resolve(apiPost('prog_action_list', generateFormData({ companyid, progid: programid }), 82)).then((data) => {
      if (!data) return false;

      const companyJourneyActions = (data.prog_action_list || []).filter((action) => Number(action.janid) === Number(journeyId));

      if (companyJourneyActions.length > 0) {
        apiStore.setItem(apiStoreKey, [now(), companyJourneyActions]);
      }

      return companyJourneyActions;
    });

    return result;
  },
  async getProgramJourneyAction(context, [actionId, journeyId, companyId, programId, refresh = false]) {
    const actions = await context.dispatch('getProgramJourneyActions', [journeyId, companyId, programId, refresh]);

    if (Array.isArray(actions)) {
      return actions.find((action) => Number(action.id) === Number(actionId));
    }

    return actions;
  },
  async saveProgramJourneyAction(context, data) {
    let badgeType;

    if (data?.isAnnouncement) {
      badgeType = 4; // announcement
    } else if (data.tip?.length && data.badgeId) {
      badgeType = 3; // both
    } else if (data.tip?.length && !data.badgeId) {
      badgeType = 1; // tip only
    } else {
      badgeType = 2; // badge only
    }

    if (data.id) {
      const request = await resolve(apiPost('edit_jan_act', generateFormData({
        actid: data.id,
        action: data.tip || '',
      }), 73));

      return request;
    }

    const request = await resolve(apiPost('prog_add_jan_act', generateFormData({
      title: data.title,
      action: data.tip || '',
      companyid: data.companyId,
      janid: data.journeyId,
      post: data.position,
      type: data.type, // user types
      badgeid: data.badgeId || '',
      badge_type: badgeType,
      progid: data.programId,
    }), 82));

    return request;
  },
  async deleteProgramJourneyAction(context, journeyActionId) {
    const result = await resolve(apiPost('prog_del_action', generateFormData({
      actid: journeyActionId,
    }), 82));

    return result;
  },
  async createProgramBadge(context, data) {
    const formData = generateFormData({
      badge_name: data.badge_name,
      senderid: context.rootState.User.id,
      companyid: data.companyid,
      progid: data.programId,
    });

    formData.append('file1', data.badge);

    const result = await resolve(apiPost('create_prog_prompt_badges', formData, 82));

    return result;
  },
  async deleteProgramBadge(context, badgeId) {
    const result = await resolve(apiPost('prog_del_badge', generateFormData({
      badgeid: badgeId,
    }), 82));

    return result;
  },
  async getProgramBadges(context, [companyId, programId]) {
    const badges = await resolve(apiPost('prog_badge_list', generateFormData({
      companyid: companyId,
      progid: programId,
    }), 82))
      .then((res) => {
        if (!res) {
          console.warn('getBadges::journeys.js Error in getting badges');
          return false;
        }

        return res.prog_badge_list;
      });
    //

    return badges;
  },
};
